import {BigWinConstants} from '@gongxigames/framework/slot';
import { Texture } from 'pixi.js';
import {bigWinStore} from '@gongxigames/framework/slotV2/modules/bigwin/bigWinStore';

export class KoalaBigWinConstants extends BigWinConstants {
    public static readonly LOOP_SOUND: string = 'bigWinLoop';
    public static override readonly BIG_WIN_TIMINGS: any = {
        animation_delay: 0,
        particles_delay: 0,
        skip_delay: 1000,
        durationCounter: {
            big_win_play: 1800,
            big_mega_win_play: 4900,
            big_mega_ultra_win_play: 10450
        },
        skipToBeforeEnd: {
            big_win_play: 1750,
            big_mega_win_play: 1750,
            big_mega_ultra_win_play: 2850
        }
    };

    public static readonly PARTICLES_SLOTS: {
        [key: string]: {
            slots: string[];
            delay: number[];
        };
    } = {
            big_win_play: {
                slots: ['emitter_bigwin'],
                delay: [100]
            },
            big_mega_win_play: {
                slots: ['emitter_bigwin', 'emitter_megawin'],
                delay: [100, 3100]
            },
            big_mega_ultra_win_play: {
                slots: ['emitter_bigwin', 'emitter_megawin', 'emitter_ultrawin'],
                delay: [100, 3100, 6500]
            }

        };

    public static PARTICLES_CONFIG(textures: Texture[][]): any {

        const anims = textures.map((textureSet) => ({
            framerate: 15,
            loop: true,
            textures: textureSet
        }));

        return {
            lifetime: {
                min: 5,
                max: 5
            },
            frequency: 0.8,
            emitterLifetime: -1,
            maxParticles: 1000,
            addAtBack: false,
            particlesPerWave: 15,
            pos: {
                x: -800,
                y: -200
            },
            behaviors: [
                {
                    type: 'blendMode',
                    config: {
                        blendMode: 'normal'
                    }
                },
                {
                    type: 'moveAcceleration',
                    config: {
                        accel: {
                            x: 0,
                            y: 1000

                        },
                        maxSpeed: 0,
                        minStart: 1000,
                        maxStart: 1200
                    }
                },
                {
                    type: 'scale',
                    config: {
                        minMult: 1,
                        scale: {
                            list:[
                                {time: 0, value: 0.6},
                                {time: 1, value: 0.9}
                            ]}
                    }
                },
                {
                    type: 'colorStatic',
                    config: {color: '#e4f9ff'}
                },
                {
                    type: 'rotation',
                    config: {accel: 0, minSpeed: 0.01, maxSpeed: 0.15, minStart: 230, maxStart: 320}
                },
                {
                    type: 'animatedRandom',
                    config: {
                        anims
                    }
                },
                {
                    type: 'spawnShape',
                    config: {
                        type: 'rect',
                        data: {x: 0, y: 0, w: 1200, h: 300}
                    }
                }
            ]
        };
    }

}